<template>
    <section class="resume col-center">
        <v-row class="resume__row px-4">
            <v-col
                cols="2"
                md="4"
                class="col-center">
                <ResumeTimeline
                    v-model="active"
                    :items="sections" />
            </v-col>
            <v-col
                cols="10"
                md="8"
                class="resume__panels col-center pa-0 ma-0">
                <transition name="stack-fade">
                    <component
                        :is="current.component"
                        :key="active"
                        v-bind="current.props"
                        class="resume__panel" />
                </transition>
            </v-col>
        </v-row>
    </section>
</template>

<script>
import { education, experience } from '@/data/resume';
import ResumeTimeline from './ResumeTimeline.vue';
import EntriesPanel from './EntriesPanel.vue';
import SkillsPanel from './SkillsPanel.vue';
import ToolsPanel from './ToolsPanel.vue';
import LanguagesPanel from './LanguagesPanel.vue';

// One timeline entry per tab, with the panel it shows.
const sections = Object.freeze([
    { title: 'Education', icon: 'mdi-school', color: 'primary', component: EntriesPanel, props: { entries: education } },
    { title: 'Skills', icon: 'mdi-code-braces', color: 'indigo', component: SkillsPanel },
    { title: 'Experience', icon: 'mdi-account-tie', color: 'blue', component: EntriesPanel, props: { entries: experience } },
    { title: 'Misc', icon: 'mdi-lightbulb-on-outline', color: 'cyan', component: ToolsPanel },
    { title: 'Language', icon: 'mdi-chat', color: 'teal', component: LanguagesPanel },
]);

export default {
    name: 'ResumeSection',
    components: { ResumeTimeline },
    data: () => ({
        sections,
        active: 0,
    }),
    computed: {
        current() {
            return this.sections[this.active];
        },
    },
};
</script>

<style scoped>
.resume {
    min-height: 100vh;
    background-color: var(--v-surface-base);
    position: relative;
    z-index: 1;
}
/* Twilight: black glass, the backdrop and its network showing through blurred. */
[data-theme='twilight'] .resume {
    --glass-opacity: 60%; /* how much black covers the backdrop */
    --glass-blur: 5px;
    --glass-saturation: 30%; /* drains the backdrop's blue */
    background-color: rgb(0 0 0 / var(--glass-opacity));
    /* Faint reflection on the top left, and a lit top edge. */
    background-image: linear-gradient(160deg, rgb(255 255 255 / 5%), transparent 40%);
    border-top: 1px solid rgb(255 255 255 / 10%);
    backdrop-filter: blur(var(--glass-blur)) saturate(var(--glass-saturation));
}
.resume__row {
    width: 100%;
    max-width: 2000px;
    margin: 0;
}
.resume__panels {
    position: relative;
    overflow-x: visible;
}
.resume__panel {
    width: 100%;
}
</style>
